import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Lock, ArrowLeft } from "lucide-react";

export default function ComingSoon({ title, blurb, phase = 2, icon: Icon }) {
  return (
    <div className="p-8 max-w-3xl mx-auto" data-testid={`coming-soon-${title.toLowerCase().replace(/\s+/g,"-")}`}>
      <div className="brut-card p-8 md:p-10 text-center relative overflow-hidden">
        <div className="absolute -right-8 -top-8 w-32 h-32 rounded-full bg-amber-200 opacity-40 float-y" />
        <div className="absolute left-10 -bottom-10 w-24 h-24 rounded-full bg-emerald-200 opacity-40 float-y" style={{ animationDelay: "1.2s" }} />
        <div className="relative">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-200 border-2 border-slate-900 font-heading font-bold text-xs uppercase tracking-widest mb-4">
            <Lock size={12} strokeWidth={3} /> Phase {phase} · Coming soon
          </div>
          <div className="mb-3 flex justify-center">
            {Icon ? (
              <div className="w-14 h-14 rounded-2xl border-2 border-slate-900 bg-white flex items-center justify-center">
                <Icon size={28} strokeWidth={2.5} />
              </div>
            ) : (
              <Sparkles className="text-slate-900" size={32} strokeWidth={2.5} />
            )}
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold mb-2">{title}</h1>
          <p className="text-slate-600 max-w-md mx-auto">{blurb}</p>
          <div className="mt-6">
            <Link to="/workforce" className="brut-btn brut-btn-outline"><ArrowLeft size={14} strokeWidth={2.5} /> Back to workforce</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
